const styles = (theme) => ({
  messageTitle: {
    padding: theme.spacing(5, 5, 3),
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.5,
  },

  message: {
    textAlign: 'center',
  },
});

export default styles;
